<template>
  <div class="">
    <Loader :show="showLoader" />

    <div class="row">
      <div class="col-10 offset-1 text-center blaSettingsBoxHeader">
        <div class="blaSettingsUserName">{{ user.name }}</div>
        <div class="row align-content-center mt-2 mb-1">
          <div class="col-12">
            <img
              v-if="profilePhoto && profilePhoto !== null"
              :src="profilePhoto"
              alt="profile_photo"
              class="blaSettingsUserPhoto"
            />
            <img
              v-else
              :src="require('@/assets/img/user.png')"
              alt="def_user_profile_photo"
              class="blaSettingsUserPhoto"
            />
          </div>
          <div class="col-12 blaSettingsUserScore">
            <img
              :src="require('@/assets/img/score.png')"
              alt="score"
              class="img-fluid blaSettingsUserScoreImg"
            />
            {{ score }}
          </div>
        </div>
      </div>
      <div class="col-10 offset-1 blaSettingsBoxContent pt-5 pb-2">
        <div class="row">
          <div v-show="message.show" class="col-10 offset-1">
            <div
              class="alert text-center"
              :class="{
                'alert-success': message.color === 'success',
                'alert-danger': message.color === 'danger',
              }"
              role="alert"
            >
              {{ message.message }}
            </div>
          </div>
          <div class="col-12 col-md-6">
            <div class="blaSettingsBoxContentAlt">Felhasználói adatok</div>
            <div class="form-group my-2">
              <label for="name">Név</label>
              <input
                v-model="user.name"
                type="text"
                class="form-control blaInput"
                id="name"
              />
            </div>
            <div class="form-group my-2">
              <label for="nickname">Nicknév</label>
              <input
                v-model="user.nickname"
                type="text"
                class="form-control blaInput"
                id="nickname"
              />
            </div>
            <div class="form-group my-2">
              <label for="email">Email cím</label>
              <input
                v-model="user.email"
                type="text"
                class="form-control blaInput"
                id="email"
                disabled
              />
            </div>
            <div class="form-group my-2">
              <label for="phone">Telefonszám</label>
              <input
                v-model="user.phone"
                type="text"
                class="form-control blaInput"
                id="phone"
              />
            </div>
          </div>
          <div class="col-12 col-md-6">
            <div class="blaSettingsBoxContentAlt mt-4 mt-md-0 mb-2">
              Számlázási adatok
            </div>
            <div class="form-group my-2">
              <label for="country">Ország</label>
              <input
                v-model="user.country"
                type="text"
                class="form-control blaInput"
                id="country"
              />
            </div>
            <div class="form-group my-2">
              <label for="zip">Irányítószám</label>
              <input
                v-model="user.zip"
                type="text"
                class="form-control blaInput"
                id="zip"
              />
            </div>
            <div class="form-group my-2">
              <label for="city">Város</label>
              <input
                v-model="user.city"
                type="text"
                class="form-control blaInput"
                id="city"
              />
            </div>
            <div class="form-group my-2">
              <label for="address">Cím</label>
              <input
                v-model="user.address"
                type="text"
                class="form-control blaInput"
                id="address"
              />
            </div>
          </div>
          <div class="col-12 col-md-6 mt-4 mt-md-4 mb-2">
            <div class="blaSettingsBoxContentAlt mt-4 mt-md-0 mb-2">
              Biztonsági adatok
            </div>
            <div class="form-group my-2">
              <label for="passwordNew">Jelszó</label>
              <input
                v-model="password.new"
                type="text"
                class="form-control blaInput"
                id="passwordNew"
              />
            </div>
            <div class="form-group my-2">
              <label for="passwordNewConfirmation">Jelszó megerősítés</label>
              <input
                v-model="password.confirmation"
                type="text"
                class="form-control blaInput"
                id="passwordNewConfirmation"
              />
            </div>
          </div>
          <div class="col-12 col-md-6 mt-4 mt-md-4 mb-2">
            <div class="blaSettingsBoxContentAlt mt-4 mt-md-0 mb-2">
              Elért kitüntetések
            </div>
            <div class="row">
              <div class="col-4 blaSettingsUserBadgeContainer">
                <div class="row">
                  <div class="col-12 blaSettingsUserBadgeAnimation">
                    <LottieAnimation
                      ref="anim"
                      :loop="true"
                      :animationData="
                        require('@/assets/img/lottie_files/bronze-coin.json')
                      "
                    />
                  </div>
                  <div class="col-12 text-center blaSettingsUserBadgeCounter">
                    {{ badges[1] }}
                  </div>
                </div>
              </div>
              <div class="col-4 blaSettingsUserBadgeContainer">
                <div class="row">
                  <div class="col-12 blaSettingsUserBadgeAnimation">
                    <LottieAnimation
                      ref="anim"
                      :loop="true"
                      :animationData="
                        require('@/assets/img/lottie_files/silver-coin.json')
                      "
                    />
                  </div>
                  <div class="col-12 text-center blaSettingsUserBadgeCounter">
                    {{ badges[2] }}
                  </div>
                </div>
              </div>
              <div class="col-4 blaSettingsUserBadgeContainer">
                <div class="row">
                  <div class="col-12 blaSettingsUserBadgeAnimation">
                    <LottieAnimation
                      ref="anim"
                      :loop="true"
                      :animationData="
                        require('@/assets/img/lottie_files/gold-coin.json')
                      "
                    />
                  </div>
                  <div class="col-12 text-center blaSettingsUserBadgeCounter">
                    {{ badges[3] }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 offset-0 col-md-6 offset-md-3 mt-2 mt-md-2 mb-2">
          <div class="col-10 offset-1 text-center align-content-center mt-4">
            <div class="blaLoginButton2" @click="setUserNewData">Mentés</div>
          </div>
          <div class="col-10 offset-1 text-center align-content-center mt-4">
            <div
              class="blaLoginButton2"
              @click="$router.push({ name: 'logout' })"
            >
              Kijelentkezés
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import LottieAnimation from "lottie-web-vue";
import Loader from "@/components/partials/Loader";

export default {
  components: { Loader, LottieAnimation },
  data: function () {
    return {
      user: {},
      loader: false,
      message: {
        show: false,
        message: "",
        timeout: 500,
        color: "",
      },
      password: {
        new: "",
        confirmation: "",
        confirmationShow: false,
        newShow: false,
      },
      rules: {
        required: (value) => !!value || "Kötelező",
      },
      score: 0,
      weeklyScore: 0,
      badges: {
        1: 0,
        2: 0,
        3: 0,
      },
      showLoader: true,
    };
  },
  methods: {
    async getUserData() {
      await axios
        .post(this.$store.getters.getApiUrl + "/api/user/getData", {
          token: this.$store.getters.getToken,
        })
        .then((response) => {
          // console.log("settings - resp: ", response.data);
          this.user = response.data.user;
          this.score = response.data.score;
          this.weeklyScore = response.data.weeklyScore;
          this.badges = response.data.badges;

          //Disable loader
          let v = this;
          setTimeout(function () {
            v.showLoader = false;
          }, 10);
        })
        .catch((error) => {
          if (error.length > 0) {
            console.log("settings - error: ", error);
          }
        });
    },
    setUserNewData() {
      axios
        .post(this.$store.getters.getApiUrl + "/api/settings/setNewUserData", {
          token: this.$store.getters.getToken,
          name: this.user.name,
          nickname: this.user.nickname,
          phone: this.user.phone,
          email: this.user.email,
          country: this.user.country,
          zip: this.user.zip,
          city: this.user.city,
          address: this.user.address,
        })
        .then((response) => {
          console.log("settings - set - data - resp: ", response.data);
          this.message.message = response.data.message;
          this.message.color = "success";
          this.message.show = true;

          let v = this;
          setTimeout(() => {
            this.message.show = false;
          }, this.message.timeout);
        })
        .catch((error) => {
          if (error.length > 0) {
            // console.log('settings - set - data - error: ', error);
            this.message.message = response.data.message;
            this.message.color = "error";
            this.message.show = true;

            let v = this;
            setTimeout(() => {
              this.message.show = false;
            }, this.message.timeout);
          }
        });
    },
    setUserNewPassword() {
      //If password match
      if (this.password.new === this.password.confirmation) {
        if (this.password.new.length >= 6) {
          axios
            .post(
              this.$store.getters.getApiUrl +
                "/api/settings/setNewUserPassword",
              {
                token: this.$store.getters.getToken,
                newPassword: this.password.new,
              }
            )
            .then((response) => {
              // console.log('settings - set - password - resp: ', response.data);
              this.message.message = response.data.message;
              this.message.color = "success";
              this.message.show = true;

              let v = this;
              setTimeout(() => {
                this.message.show = false;
              }, this.message.timeout);
            })
            .catch((error) => {
              if (error.length > 0) {
                // console.log('settings - set - password - error: ', error);
                this.message.message = response.data.message;
                this.message.color = "error";
                this.message.show = true;

                let v = this;
                setTimeout(() => {
                  this.message.show = false;
                }, this.message.timeout);
              }
            });
        } else {
          this.message.message =
            "Jelszónak legalább 6 karakternek kell lennie!";
          this.message.show = true;
        }
      } else {
        this.message.message = "Nem egyező jelszavak!";
        this.message.show = true;
      }
    },
  },
  computed: {
    profilePhoto() {
      if (
        this.$store.getters.currentUser.profile_photo !== undefined &&
        this.$store.getters.currentUser.profile_photo !== null
      ) {
        return (
          this.$store.getters.getApiUrl +
          "/uploads/profile_photos/" +
          this.$store.getters.currentUser.profile_photo
        );
      } else {
        return (
          this.$store.getters.getApiUrl + "/uploads/profile_photos/default.png"
        );
      }
    },
  },
  mounted: function () {
    this.getUserData();
  },
};
</script>
